import * as React from 'react';
import Icon from './Icon';
import Button from './Button';

interface ErrorToastProps {
	errors: any[];
	onDismiss(error: any): void;
}

export default class ErrorToast extends React.Component<ErrorToastProps, {}> {

	public render() {
		if (!this.props.errors.length) {
			return null;
		}
		return <div className='error-toast'>
			{this.props.errors.map(this.renderErrorLine.bind(this))}
		</div>;
	}

	private renderErrorLine(error: any, key: number) {
		return <div key={key} className='error-toast-line'>
			<Icon name='exclamation-triangle' fixedWidth />
			{error.message}
			<Button
				className='dismiss-button'
				size='small'
				onClick={this.props.onDismiss.bind(null, error)}
			>
				dismiss
			</Button>
		</div>;
	}

}



// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./ts/components/util/widgets/ErrorToast.tsx